import Button from '../../atoms/buttons/addonButton';
import Focus from '../../../../shared/types/enums/focus';
import { useAppSelector } from '../../../../shared/store/hooks';
import { magicRemoteSelector } from '../../../../shared/store/slices/magicRemote.slice';
import { focusSelector } from '../../../../shared/store/slices/focus.slice';

function AddonButton({
  canClick,
  focus,
  item,
  action,
  releaseAction,
}: {
  canClick: boolean;
  focus: Focus;
  item: string;
  action?: () => void;
  releaseAction?: () => void;
}) {
  const { focus: currentFocus } = useAppSelector(focusSelector);
  const { enabled } = useAppSelector(magicRemoteSelector);
  return (
    <Button
      canClick={canClick}
      onClick={action || releaseAction}
      focused={!enabled && currentFocus === focus}
    >
      {item}
    </Button>
  );
}

export default AddonButton;
